import { CellContext } from "@tanstack/react-table"

import { UITypes } from "types"

import { OrderStatusBadge } from "components/common/OrderStatusBadge"

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const StatusOfOrder = ({ cell: { getValue } }: Props) => {
  const status = getValue().value ? String(getValue().value) : ""
  return <OrderStatusBadge status={status} />
}
